// utils.js
// Utility functions for the TeamAvailability component

import { format } from "date-fns";

// Format date to YYYY-MM-DD for API requests
export const formatDateForApi = (date) => {
  return format(date, "yyyy-MM-dd");
};

// Parse time string (like "9:30am") to hour number for sorting and comparison
export const parseTimeStringToHour = (timeStr) => {
  try {
    if (!timeStr) return 0;

    // Handle "Unavailable all day" case
    if (timeStr === "Unavailable all day") return 0;

    // Handle different time formats
    if (
      timeStr.toLowerCase().includes("am") ||
      timeStr.toLowerCase().includes("pm")
    ) {
      // 12-hour format like "9:30am"
      const isPM = timeStr.toLowerCase().includes("pm");
      const timePart = timeStr.toLowerCase().split(/am|pm/)[0].trim();
      const [hours, minutes] = timePart
        .split(":")
        .map((num) => parseInt(num.trim(), 10));

      // Convert to 24-hour
      let hour24 = hours;
      if (isPM && hours < 12) {
        hour24 = hours + 12;
      } else if (!isPM && hours === 12) {
        hour24 = 0;
      }

      return hour24 + (minutes ? minutes / 60 : 0);
    } else {
      // 24-hour format like "14:30"
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours + (minutes ? minutes / 60 : 0);
    }
  } catch (error) {
    console.error("Error parsing time string:", error);
    return 0;
  }
};

// Get initials for avatars
export const getInitials = (name) => {
  if (!name) return "?";

  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

// Format date for display
export const formatDisplayDate = (date) => {
  return format(date, "EEEE, MMMM d, yyyy");
};
